import { render, staticRenderFns } from "./SwipeCards.vue?vue&type=template&id=3cdb4234&scoped=true"
import script from "./SwipeCards.vue?vue&type=script&lang=js"
export * from "./SwipeCards.vue?vue&type=script&lang=js"
import style0 from "./SwipeCards.vue?vue&type=style&index=0&id=3cdb4234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdb4234",
  null
  
)

export default component.exports